export const UI_OPEN_APPROVAL_MODAL = "UI/APPROVAL_MODAL/OPEN";
export const UI_CLOSE_APPROVAL_MODAL = "UI/APPROVAL_MODAL/CLOSE";
